import { AutocompleteWithLabel } from '@adotel/components'
import { useQuery } from '@apollo/client'
import { IconButton } from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React, { useState } from 'react'

import SectionTitle from '../../components/SectionTitle'
import { GATEWAYS_LIST_QUERY } from '../../graphql/gateways'
import { getTranslate } from '../../localization'
import '../../types/accommodation'
import { ProviderSubmit } from '../../types/accommodationProviderSubmit'
import { Gateway } from '../../types/gateway'
import useStyles from './Styles/ProviderAssociatedGateways.style'

interface ProviderAssociatedGatewaysProps {
  selectedProviderSubmit: ProviderSubmit[]
  setSelectedProviderSubmit: React.Dispatch<
    React.SetStateAction<ProviderSubmit[]>
  >
  selectedProviderSubmitIndex: number
}

export default function ProviderAssociatedGateways({
  selectedProviderSubmit,
  setSelectedProviderSubmit,
  selectedProviderSubmitIndex
}: ProviderAssociatedGatewaysProps) {
  const classes = useStyles()
  const [clickOnConnections, setClickOnConnections] = useState(false)

  const [autoCompleteLabelGateways, setAutoCompleteLabelGateways] = useState<
    any[]
  >([])

  const { loading: loadingForGateways, data: gatewaysData } = useQuery<{
    gateways: Gateway[]
  }>(GATEWAYS_LIST_QUERY, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      const provider = selectedProviderSubmit?.[selectedProviderSubmitIndex]

      if (provider?.associatedGateways) {
        setAutoCompleteLabelGateways(
          provider.associatedGateways.map((ele) => {
            const foundGateway = res.gateways.find(
              (gw) => gw.basicDetails.gatewayId === ele
            )

            return {
              value: ele,
              label: `${foundGateway?.basicDetails?.name ?? ''} (${
                foundGateway?.basicDetails?.entity ?? ''
              } - ${foundGateway?.basicDetails?.entityCode ?? ''})`
            }
          })
        )
      }
    }
  })

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <SectionTitle title="Associated Gateways" marginBottom />
        <IconButton
          className={classes.iconButton}
          onClick={() => {
            setClickOnConnections(!clickOnConnections)
          }}>
          {clickOnConnections ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </div>
      {clickOnConnections && (
        <div className={classes.container}>
          <AutocompleteWithLabel
            name="AssociatedGateways"
            inputSize="small"
            multiple
            loading={loadingForGateways}
            loadingText={getTranslate('Loading') + '...'}
            options={
              gatewaysData?.gateways.map((item) => {
                return {
                  value: item.basicDetails.gatewayId,
                  label: `${item.basicDetails.name} (${item.basicDetails.entity} - ${item.basicDetails.displayEntityCode})`
                }
              }) || []
            }
            size="medium"
            label={getTranslate('Associated Gateways')}
            placeholder={getTranslate('Select the Associated Gateway')}
            value={autoCompleteLabelGateways}
            onChange={(_, v: any[]) => {
              if (v.length > 0) {
                const selectedGateways: string[] = []
                const labelGateways = v.map((item) => {
                  selectedGateways.push(item.value)
                  return {
                    label: item.label,
                    value: item.value
                  }
                })

                setSelectedProviderSubmit((prev) => [
                  ...prev.slice(0, selectedProviderSubmitIndex),
                  {
                    ...prev[selectedProviderSubmitIndex],
                    associatedGateways: selectedGateways
                  },
                  ...prev.slice(selectedProviderSubmitIndex + 1)
                ])

                setAutoCompleteLabelGateways(labelGateways)
              } else {
                setAutoCompleteLabelGateways([])
              }
            }}
          />
        </div>
      )}
    </div>
  )
}
